import { render, staticRenderFns } from "./create-template.vue?vue&type=template&id=6b60f258&scoped=true&"
import script from "./create-template.vue?vue&type=script&lang=ts&"
export * from "./create-template.vue?vue&type=script&lang=ts&"
import style0 from "./create-template.vue?vue&type=style&index=0&id=6b60f258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b60f258",
  null
  
)

export default component.exports